import type { AjaxError } from 'rxjs/observable/dom/AjaxObservable';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';

export const FETCH_LINKED_SPACES = 'state.actions.linked-spaces.FETCH_LINKED_SPACES' as const;
export const FETCH_LINKED_SPACES_SUCCESS =
	'state.actions.linked-spaces.FETCH_LINKED_SPACES_SUCCESS' as const;
export const FETCH_LINKED_SPACES_FAILURE =
	'state.actions.linked-spaces.FETCH_LINKED_SPACES_FAILURE' as const;

interface AnalyticsMetaData {
	analyticsSuccessEvent?: UIAnalyticsEvent;
	analyticsFailureEvent?: UIAnalyticsEvent;
}
export interface FetchLinkedSpacesAction {
	type: typeof FETCH_LINKED_SPACES;
	payload: {
		meta?: AnalyticsMetaData;
	};
}

export interface FetchLinkedSpacesSuccessAction {
	type: typeof FETCH_LINKED_SPACES_SUCCESS;
	payload: {
		linkedSpaces: string[];
	};
}

export interface FetchLinkedSpacesFailureAction {
	type: typeof FETCH_LINKED_SPACES_FAILURE;
	payload: {
		error: AjaxError;
	};
}

export const fetchLinkedSpaces = (meta?: AnalyticsMetaData): FetchLinkedSpacesAction => ({
	type: FETCH_LINKED_SPACES,
	payload: {
		meta,
	},
});

export const fetchLinkedSpacesSuccess = (
	linkedSpaces: string[],
): FetchLinkedSpacesSuccessAction => ({
	type: FETCH_LINKED_SPACES_SUCCESS,
	payload: {
		linkedSpaces,
	},
});

export const fetchLinkedSpacesFailure = (error: AjaxError): FetchLinkedSpacesFailureAction => ({
	type: FETCH_LINKED_SPACES_FAILURE,
	payload: {
		error,
	},
});
